var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlansIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chart-histogram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.928,
    height: 21.928,
    viewBox: "0 0 21.928 21.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37598",
    "data-name": "Path 37598",
    d: "M21.014,20.1H4.568a2.741,2.741,0,0,1-2.741-2.741V.914A.914.914,0,1,0,0,.914V17.359a4.574,4.574,0,0,0,4.568,4.568H21.014a.914.914,0,1,0,0-1.827Z",
    transform: "translate(0 0)",
    fill: "#ff643a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37599",
    "data-name": "Path 37599",
    d: "M5.98,19.817a.98.98,0,0,0,.98-.98V11.98A.98.98,0,0,0,5,11.98v6.858A.98.98,0,0,0,5.98,19.817Z",
    transform: "translate(-0.462 -1.385)",
    fill: "#ff643a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37600",
    "data-name": "Path 37600",
    d: "M10,9.98V18.8a.98.98,0,1,0,1.959,0V9.98A.98.98,0,1,0,10,9.98Z",
    transform: "translate(-0.923 -1.28)",
    fill: "#ff643a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37601",
    "data-name": "Path 37601",
    d: "M15,12.98v5.878a.98.98,0,0,0,1.959,0V12.98a.98.98,0,0,0-1.959,0Z",
    transform: "translate(-1.385 -1.432)",
    fill: "#ff643a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37602",
    "data-name": "Path 37602",
    d: "M20,8.98v9.8a.98.98,0,0,0,1.959,0V8.98A.98.98,0,1,0,20,8.98Z",
    transform: "translate(-1.991 -1.219)",
    fill: "#ff643a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37603",
    "data-name": "Path 37603",
    d: "M5.98,8.817a.98.98,0,0,0,.692-.287l3.513-3.513a1,1,0,0,1,1.385,0L13.7,7.145a2.939,2.939,0,0,0,4.156,0l5.472-5.472A.98.98,0,1,0,21.941.287L16.469,5.758a.98.98,0,0,1-1.385,0L12.956,3.632a2.939,2.939,0,0,0-4.156,0L5.287,7.145A.98.98,0,0,0,5.98,8.817Z",
    transform: "translate(-1.686 0)",
    fill: "#ff643a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansIcon5);
export default __webpack_public_path__ + "static/media/plans-icon5.339d491fd3ce39e109557eb2b442829b.svg";
export { ForwardRef as ReactComponent };